import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getR2DSupplierFacets } from "../services";

export const useAllSupplierFacets = (
  supplierFilter: string = "all",
  isApiConfigReady: boolean = false,
  activeTab?: string,
  refetchIntervalMs?: number
) => {
  const { data, isLoading, refetch, dataUpdatedAt } = useQuery({
    queryKey: ["allSupplierFacets", activeTab],
    queryFn: () => getR2DSupplierFacets(undefined, {}, activeTab),
    enabled: isApiConfigReady,
    staleTime: refetchIntervalMs || 10 * 60 * 1000,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  const filteredSuppliers = useMemo(() => {
    return (
      data?.suppliers?.filter((supplier: any) => {
        const matchesSupplierFilter =
          supplierFilter === "all" || supplierFilter === supplier._id;
        return matchesSupplierFilter;
      }) || []
    );
  }, [data?.suppliers, supplierFilter]);

  return {
    facets: data,
    loading: isLoading,
    filteredSuppliers,
    refetch,
    dataUpdatedAt,
  };
};

